import React from "react";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Title from "../../ui/title";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import Content from "../../ui/content";
import { withStyles } from "material-ui/styles";
import Input, { InputLabel } from "material-ui/Input";
import Grid from "material-ui/Grid";
import styles from "./styles";
import SearchTarget from "../common/searchTarget";
import ConfirmDialog from "../../common/dialog/confirm";
import { validateFormData } from "../../../common/formtool";

import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { withRouter } from "react-router-dom";
import {
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";

import NoData from "../../nodata";
import Loading from "../../loading";

class Tr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trErrors: {},
      logo: null,
      selectedTrResult: null,
      subTestTargetResult: this.props.subTestTargetResult,
      isChanged: false,
      searchModal: null,
      showConfirmBack: false,
      deleteTargetId: null,
      selectedTest: this.props.selectedTest,
      isRestore: false,
      isTraceRouteUpdate: false
    };
    this.onTextChange = this.onTextChange.bind(this);
    this.onTargetSearchSelect = this.onTargetSearchSelect.bind(this);
    this.onTargetSave = this.onTargetSave.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onBackYesClick = this.onBackYesClick.bind(this);
    this.onBackNoClick = this.onBackNoClick.bind(this);
    this.hideBackConfirmModal = this.hideBackConfirmModal.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.onLookupChange = this.onLookupChange.bind(this);
  }
  componentWillMount() {
    const {
      traceroute4Details,
      traceroute6Details,
      isTestEdit,
      selectedTest,
      testEdit,
      modified
    } = this.props;
    if (isTestEdit) {
      this.props.getPingTargetList(this.props.customerId);
    } else {
      this.props.getPingTargetList(null);
    }
    if (testEdit) {
      const { sessionStorage } = window;
      if (
        isTestEdit &&
        selectedTest.includes("traceroute4") &&
        !modified &&
        traceroute4Details
      ) {
        sessionStorage.setItem(
          "TR4DEFAULT",
          JSON.stringify(traceroute4Details)
        );
      } else if (
        isTestEdit &&
        selectedTest.includes("traceroute6") &&
        !modified &&
        traceroute6Details
      ) {
        sessionStorage.setItem(
          "TR6DEFAULT",
          JSON.stringify(traceroute6Details)
        );
      } else if (!isTestEdit) {
        this.props.getPingDetails(this.props.selectedTest);
      } else {
        if (
          isTestEdit &&
          selectedTest.includes("traceroute4") &&
          !traceroute4Details
        ) {
          this.props.getTrDetails(this.props.selectedTest);
        } else if (
          isTestEdit &&
          selectedTest.includes("traceroute6") &&
          !traceroute6Details
        ) {
          this.props.getTrDetails(this.props.selectedTest);
        } else if (!isTestEdit) {
          this.props.getTrDetails(this.props.selectedTest);
        }
      }
    } else {
      if (
        isTestEdit &&
        selectedTest.includes("traceroute4") &&
        !traceroute4Details
      ) {
        this.props.getTrDetails(this.props.selectedTest);
      } else if (
        isTestEdit &&
        selectedTest.includes("traceroute6") &&
        !traceroute6Details
      ) {
        this.props.getTrDetails(this.props.selectedTest);
      } else if (!isTestEdit) {
        this.props.getTrDetails(this.props.selectedTest);
      }
    }
  }

  componentWillUnmount() {
    this.setState({ selectedTrResult: null, subTestTargetResult: null });
  }

  componentWillReceiveProps(nextProps) {
    const {
      subTestTargetResult,
      trErrors,
      selectedTrResult,
      traceroute4Details,
      traceroute6Details,
      isTestEdit,
      selectedTest
    } = nextProps;
    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({
        selectedTrResult,
        trErrors: trErrors
      });
      if (isTestEdit) {
        const { sessionStorage } = window;
        if (
          selectedTest.includes("traceroute4") &&
          selectedTrResult.targettype.includes("traceroute4")
        ) {
          sessionStorage.setItem(
            "TR4DEFAULT",
            JSON.stringify(selectedTrResult)
          );
        } else if (
          selectedTrResult.targettype.includes("traceroute6") &&
          selectedTest.includes("traceroute6")
        ) {
          sessionStorage.setItem(
            "TR6DEFAULT",
            JSON.stringify(selectedTrResult)
          );
        }
      }
    }
    if (
      subTestTargetResult &&
      this.props.subTestTargetResult != subTestTargetResult
    ) {
      this.setState({
        subTestTargetResult: subTestTargetResult
      });
    }
    if (isTestEdit) {
      if (
        (traceroute4Details &&
          traceroute4Details !== this.props.traceroute4Details) ||
        (traceroute4Details && !this.state.isTraceRouteUpdate)
      ) {
        this.setState({
          subTestTargetResult: subTestTargetResult,
          selectedTrResult: traceroute4Details,
          trErrors: trErrors,
          isTraceRouteUpdate: true
        });
      } else if (
        (traceroute6Details &&
          traceroute6Details !== this.props.traceroute6Details) ||
        (traceroute6Details && !this.state.isTraceRouteUpdate)
      ) {
        this.setState({
          subTestTargetResult: subTestTargetResult,
          selectedTrResult: traceroute6Details,
          trErrors: trErrors,
          isTraceRouteUpdate: true
        });
      }
    }
    // this.setState({
    //   subTestTargetResult: subTestTargetResult,
    //   selectedTrResult,
    //   trErrors: trErrors
    // });
  }

  componentWillUpdate(prevProps, prevState) {
    if (this.props.isTestEdit) {
      const { subTestTargetResult, trErrors, selectedTrResult } = this.props;
      if (selectedTrResult && prevProps.selectedTrResult != selectedTrResult) {
        this.setState({
          selectedTrResult,
          trErrors: trErrors
        });
      }
      // if (subTestTargetResult && prevProps.subTestTargetResult != subTestTargetResult) {
      //   this.setState({
      //     subTestTargetResult: subTestTargetResult
      //   });
      // }
    }
  }

  onTextChange(e) {
    const { translate } = this.props;
    let vObj = {};
    let trErrors = { ...this.state.trErrors };

    let selectedTrResult = { ...this.state.selectedTrResult };
    selectedTrResult[e.target.name] =
      e.target.name === "target"
        ? e.target.value
        : e.target.value == 0
        ? e.target.value
        : Number(e.target.value)
        ? Number(e.target.value)
        : "";

    if (e.target.name.includes("target")) {
      vObj[e.target.name] = {
        maxCharacter: {
          length: 256,
          message: translate("subtest_target_length_validation", {
            value: 256
          })
        }
      };
      let trError = validateFormData(selectedTrResult, vObj);
      if (Object.keys(trError).length) {
        trErrors = {
          ...trErrors,
          [e.target.name]: trError[e.target.name]
        };
        this.setState({
          trErrors,
          selectedTrResult,
          isChanged: false,
          isRestore: false
        });
      } else {
        trErrors = {
          ...trErrors,
          [e.target.name]: false
        };
        this.setState({
          selectedTrResult,
          isChanged: true,
          trErrors,
          isRestore: false
        });
      }
    } else {
      trErrors = {
        ...trErrors,
        [e.target.name]: false
      };
      this.setState({
        selectedTrResult,
        isChanged: true,
        trErrors,
        isRestore: false
      });
    }
  }
  onTypeChange = e => {
    let selectedTrResult = { ...this.state.selectedTrResult };
    selectedTrResult["type"] = e.target.value;
    this.setState({ selectedTrResult, isChanged: true, isRestore: false });
  };
  onLookupChange = e => {
    let selectedTrResult = { ...this.state.selectedTrResult };
    selectedTrResult["namelookup"] = e.target.checked;
    this.setState({ selectedTrResult, isChanged: true, isRestore: false });
  };

  onTargetSave = () => {
    let selectedTrResult = { ...this.state.selectedTrResult };
    let { translate } = this.props;
    this.setState(
      {
        isChanged: true
      },
      () => {
        let vObj = {
          target: {
            required: translate("formfield_error_general_required"),
            maxCharacter: {
              length: 256,
              message: translate("subtest_target_length_validation", {
                value: 256
              })
            }
          },
          maxhops: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 2,
              maxValue: 100,
              message: translate("sub_test_ping_validation_range", {
                name: "Max Hops",
                value1: 2,
                value2: 100
              })
            }
          },
          timeout: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 2,
              maxValue: 30,
              message: translate("sub_test_ping_validation_range", {
                name: "Timeout",
                value1: 2,
                value2: 30
              })
            }
          }
        };
        let trErrors = validateFormData(selectedTrResult, vObj);
        const missingFieldName = Object.keys(trErrors)[0];
        if (missingFieldName) {
          const textField = document.getElementsByName(missingFieldName)[0];
          textField && textField.focus();
        }
        if (Object.keys(trErrors).length) {
          this.setState({ trErrors: trErrors });
        } else {
          let self = this;
          this.setState({
            isChanged: false,
            selectedTrResult
          });
          this.props.updateTrDetails(this.state.selectedTest, selectedTrResult);
          if (this.state.isRestore) {
            this.props.deleteDefaultSubtests(this.state.selectedTest);
          }
          if (this.props.isTestEdit) {
            this.props.handleClose();
          }
        }
      }
    );
  };

  onTargetSearchOpen = () => {
    this.setState({
      searchModal: true
    });
  };

  onTargetSearchClose = () => {
    this.setState({
      searchModal: false
    });
  };

  onTargetSearchSelect = selectedTarget => {
    let trErrors = { ...this.state.trErrors };
    trErrors = {
      ...trErrors,
      ["target"]: false
    };
    let selectedTrResult = { ...this.state.selectedTrResult };
    selectedTrResult["target"] = selectedTarget.url;
    this.setState({
      selectedTrResult,
      isChanged: true,
      searchModal: false,
      trErrors
    });
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };
  onBackYesClick = () => {
    this.onTargetSave();
    this.setState({
      showConfirmBack: false
    });
  };
  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  onRestoreConfirm = () => {
    //this.props.updateTrDetails(this.state.selectedTest, this.props.selectedTrResult);
    let defaultValue = null;
    const { sessionStorage } = window;
    if (this.props.selectedTest.includes("traceroute4")) {
      defaultValue = JSON.parse(sessionStorage.getItem("TR4DEFAULT"));
    } else {
      defaultValue = JSON.parse(sessionStorage.getItem("TR6DEFAULT"));
    }
    this.setState({
      selectedTrResult: defaultValue,
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      traceroute4Details,
      traceroute6Details,
      testEdit,
      modified
    } = this.props;
    const {
      isChanged,
      searchModal,
      trErrors,
      selectedTrResult,
      subTestTargetResult,
      isRestore
    } = this.state;
    const typeList = [
      {
        id: 0,
        type: "ICMP"
      },
      {
        id: 1,
        type: "UDP"
      }
    ];

    let $modal = null;
    if (searchModal) {
      $modal = (
        <SearchTarget
          languages={languages}
          modal={searchModal}
          close={this.onTargetSearchClose}
          targetList={subTestTargetResult}
          selectTarget={this.onTargetSearchSelect}
          translate={translate}
          selectedTest={selectedTest.includes("traceroute4") ? "IPv4" : "IPv6"}
          isTestEdit={isTestEdit}
        />
      );
    }
    let confirmDeleteText = translate("sub_test_delete_confirm_text");

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={
              selectedTest === "traceroute4"
                ? translate("general_sub_test_tr4")
                : translate("general_sub_test_tr6")
            }
          />
        )}
        <Content translate={translate}>
          {selectedTrResult && (
            <Grid container spacing={1}>
              <Grid item xs={isTestEdit ? 0 : 2}></Grid>
              <Grid item xs={isTestEdit ? 12 : 8}>
                <div className={classes.mainBody}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <TextField
                      className={classes.textFieldR}
                      error={trErrors && trErrors.target ? true : false}
                      name="target"
                      label={translate("subset_tr_target")}
                      margin="normal"
                      value={selectedTrResult ? selectedTrResult.target : ""}
                      helperText={
                        trErrors && trErrors.target ? trErrors.target : ""
                      }
                      onChange={this.onTextChange}
                    />
                    <IconButton
                      style={{ marginTop: "25px" }}
                      onClick={() => this.onTargetSearchOpen()}
                    >
                      <Icon color="primary"> search </Icon>
                    </IconButton>
                  </div>
                  <TextField
                    className={classes.textFieldL}
                    error={trErrors && trErrors.maxhops ? true : false}
                    name="maxhops"
                    label={translate("subset_tr_hops")}
                    margin="normal"
                    value={selectedTrResult ? selectedTrResult.maxhops : ""}
                    helperText={
                      trErrors && trErrors.maxhops ? trErrors.maxhops : ""
                    }
                    onChange={this.onTextChange}
                  />
                  <TextField
                    className={classes.textFieldL}
                    error={trErrors && trErrors.timeout ? true : false}
                    name="timeout"
                    label={translate("subset_tr_timeout")}
                    margin="normal"
                    value={selectedTrResult ? selectedTrResult.timeout : ""}
                    helperText={
                      trErrors && trErrors.timeout ? trErrors.timeout : ""
                    }
                    onChange={this.onTextChange}
                  />
                  <FormControl
                    className={classes.textFieldL}
                    margin="normal"
                    //error={errors.deviceid}
                  >
                    <InputLabel htmlFor="device">
                      {translate("subset_tr_type")}
                    </InputLabel>
                    <Select
                      value={selectedTrResult ? selectedTrResult.type : ""}
                      onChange={this.onTypeChange}
                      input={
                        <Input
                          name="type"
                          id="type"
                          value={selectedTrResult ? selectedTrResult.type : ""}
                          defaultValue={
                            selectedTrResult ? selectedTrResult.type : ""
                          }
                        />
                      }
                      fullWidth
                    >
                      {typeList
                        ? typeList.map((item, index) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.type}
                              </MenuItem>
                            );
                          })
                        : null}
                    </Select>
                  </FormControl>
                  <FormControlLabel
                    className={classes.textFieldL}
                    control={
                      <Checkbox
                        checked={
                          selectedTrResult ? selectedTrResult.namelookup : false
                        }
                        onChange={this.onLookupChange}
                        value={
                          selectedTrResult ? selectedTrResult.namelookup : false
                        }
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={classes.lookup}>
                        {translate("subset_tr_name_lookup")}
                      </Typography>
                    }
                  />
                  {!isTestEdit && (
                    <div align="right">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={() => this.onTargetSave()}
                      >
                        {translate
                          ? translate("sub_set_ping_save_target")
                          : "Save"}
                      </Button>
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={isTestEdit ? 0 : 2}></Grid>
              {$modal}

              {!isTestEdit && (
                <ConfirmDialog
                  open={this.state.showConfirmBack}
                  title={translate("sub_test_ping_delete_confirm_title", {
                    name: selectedTest
                  })}
                  contentText={translate("sub_test_go_back_confirm_text")}
                  //okText={translate("general_confirm")}
                  cancelText={translate("general_cancel")}
                  //onOk={this.onTargetConfirmDelete}
                  onCancel={this.hideBackConfirmModal}
                  yesText={translate("back_btn_yes")}
                  noText={translate("back_btn_no")}
                  backText={translate("back_btn_go_back")}
                  onYes={this.onBackYesClick}
                  onNo={this.onBackNoClick}
                  onBack={this.hideBackConfirmModal}
                />
              )}
              {isTestEdit && (
                <ConfirmDialog
                  open={this.state.showRestoreConfirm}
                  title={
                    testEdit
                      ? translate("test_edit_title")
                      : translate("test_add")
                  }
                  contentText={translate("restore_go_back_confirm_text")}
                  contentSecondaryText={translate(
                    "general_confirmation_help_2"
                  )}
                  okText={translate("general_confirm")}
                  cancelText={translate("general_cancel")}
                  onOk={this.onRestoreConfirm}
                  onCancel={this.hideRestoreConfirmModal}
                />
              )}
              {isTestEdit && (
                <ConfirmDialog
                  open={this.props.showTestCreationCancelConfirmation}
                  title={
                    testEdit
                      ? translate("test_edit_title")
                      : translate("test_add")
                  }
                  contentText={translate("st_test_go_back_confirm_text")}
                  contentSecondaryText={translate(
                    "general_confirmation_help_2"
                  )}
                  okText={translate("general_confirm")}
                  cancelText={translate("general_cancel")}
                  onOk={this.props.onTestCreationCancelConfirm}
                  onCancel={this.props.hideTestCreationCancelConfirm}
                />
              )}
            </Grid>
          )}
        </Content>
        {isTestEdit && selectedTrResult && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "inline-block", marginLeft: "20px" }}>
              {selectedTest === "traceroute4" ? (
                traceroute4Details && !testEdit ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : (
                  testEdit &&
                  modified && (
                    <Button
                      color="primary"
                      onClick={() => this.onResetDetails()}
                      disabled={isRestore}
                      className={classes.restoreButton}
                    >
                      <Icon> restore </Icon>{" "}
                      {translate("restore_default_settings")}
                    </Button>
                  )
                )
              ) : traceroute6Details && !testEdit ? (
                <Button
                  className={classes.restoreButton}
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : (
                testEdit &&
                modified && (
                  <Button
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    disabled={isRestore}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                )
              )}
            </div>
            <div style={{ display: "inline-block", marginRight: "20px" }}>
              <Button
                className={classes.saveTarget}
                disabled={!isChanged}
                color="accent"
                raised
                onClick={() => this.onTargetSave()}
              >
                {translate("general_continue")}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}

export default withRouter(withStyles(styles)(Tr));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/tr/index.js